import React from 'react'
import { useOnceOffExportContext } from 'hooks/context/useOnceOffExportContext'
import { OnceOffExportForm } from './OnceOffExportForm'

interface OnceOffExportType {
  downloadAll: boolean
}

export const OnceOffExport = ({ downloadAll }: OnceOffExportType) => {
  const { setExportFormat } = useOnceOffExportContext()

  return <OnceOffExportForm downloadAll={downloadAll} setExportFormat={setExportFormat} />
}
